import { isTag, isOneOfTags, isElementNode } from 'anodum';
import { IMAGE_SELECTOR } from '../../hdrm/constants/image-selector';
import site from '../../site';
import { IMAGE_TAG, LINK_TAG } from '../constants/editable-elements';
import unwrapElement from './unwrap-element';
import hasContentEditableAncestor from '../verifiers/has-content-editable-ancestor';
import createMediaContainer from '../../text-formatting/helpers/create-media-container';

const handleMediaElement = (element) => {
  if (!isOneOfTags(element, [IMAGE_SELECTOR, IMAGE_TAG]) || hasContentEditableAncestor(element)) {
    return element;
  }

  const containerAttrs = {};
  const contentPosition = element.getAttribute('content-position');
  const contentScale = element.getAttribute('content-scale');
  const aspectRatio = element.getAttribute('aspect-ratio');

  if (contentPosition) {
    containerAttrs.contentPosition = contentPosition;
  }
  if (contentScale) {
    containerAttrs.contentScale = contentScale;
  }
  if (aspectRatio) {
    containerAttrs.aspectRatio = aspectRatio;
  }

  const img = element.querySelector(IMAGE_TAG) || element;
  const alt = img.getAttribute('alt');
  const imgAttrs = {
    src: site.helpers.removeAssetUrl(img.getAttribute('src')),
  };

  if (alt) {
    imgAttrs.alt = alt;
  }

  const mediaContainerParams = [containerAttrs, imgAttrs];
  const imageParent = img.parentNode;
  if (isElementNode(imageParent) && isTag(imageParent, LINK_TAG)) {
    const href = imageParent.getAttribute('href');
    const rel = imageParent.getAttribute('rel');
    const target = imageParent.getAttribute('target');
    const download = imageParent.getAttribute('download');
    mediaContainerParams.push({ href, rel, target, download });
    if (imageParent.childElementCount === 1) unwrapElement(imageParent);
  }

  const newElement = createMediaContainer(...mediaContainerParams);

  if (element.outerHTML !== newElement.outerHTML) {
    element.replaceWith(newElement);
  }

  return newElement;
};

export default handleMediaElement;
